const Events = {
	WEBRTC_NOT_SUPPORT : 'WEBRTC_NOT_SUPPORT',
	WEBRTC_ICE_CANDIDATE_ERROR : 'WEBRTC_ICE_CANDIDATE_ERROR',
	WEBRTC_OFFER_ANWSER_EXCHANGE_FAILED:'WEBRTC_OFFER_ANWSER_EXCHANGE_FAILED',
	WEBRTC_ON_REMOTE_STREAMS:'WEBRTC_ON_REMOTE_STREAMS',
	WEBRTC_ON_LOCAL_STREAM:'WEBRTC_ON_LOCAL_STREAM',
	CAPTURE_STREAM_FAILED:'CAPTURE_STREAM_FAILED'
};

export default Events;